<template>
	<div class="livingBox flex-center" :style="{'--lineHeight':lineHeight,'--lineGap':lineGap,'--lineWeight':lineWeight,background}">
		<div :class="{living_icon:true,unlive_icon:!isLive}">
		    <div v-for="i in 4" :key="i" class="item" :style="{background:lineColor,}"></div>
		</div>
        <div class="text" v-if="showText">{{$t('components.customIcon.livingIcon_liveing', '直播中')}}</div>
	</div>
</template>

<script setup>
	import {ref,watch} from 'vue';
	let props = defineProps({
		modelValue:{
			type:Boolean,
			default:true
		},
		lineHeight:{
			type:[Number,String],
			default:10
		},
		lineGap:{
			type:[Number,String],
			default:3
		},
		lineWeight:{
			type:[Number,String],
			default:2
		},
		showText:{
			type:Boolean,
			default:true
		},
		background:{
			type:String,
			default:'',
		},
		lineColor:{
			type:String,
			default:'',
		},
	})
	let isLive = ref(true);
	let lineHeight = ref("15px"),
		lineGap = ref("3px"),
		lineWeight = ref('2px');
	watch(()=>props.modelValue,(v)=>{
		isLive.value = v;
	},{immediate:true})
	watch(()=>[props.lineHeight,props.lineGap,props.lineWeight],(vArr)=>{
		let fields = [lineHeight,lineGap,lineWeight];
		vArr.forEach((v,i)=>{
			let _v = v;
			if(new RegExp('^[0-9]*$').test(v)){
				_v = v + 'px';
			}
			fields[i].value = _v;
		})
	},{immediate:true})
</script>

<style lang="scss" scoped>
    .livingBox {
        position: absolute;
        right: 0;
        top: 0;
        font-weight: 400;
        font-size: 12px;
        color: #FFFFFF;
        width: 40px;
        height: 20px;
        background: linear-gradient(286deg, #FF0000 0%, #FF0000 100%);
        border-radius: 0px 10px 0px 10px;
        font-family: PingFang-SC-Bold;
        .living_icon {
            display: flex;
            align-items: flex-end;
            justify-content: center;

            .item {
                background: #ffffff;
                width: var(--lineWeight);
                border-radius: 1px;

                & + .item {
                    margin-left: var(--lineGap);
                }

                &:nth-child(1) {
                    height: calc(var(--lineHeight) / 2);
                }

                &:nth-child(2) {
                    height: calc(var(--lineHeight) / 2 + (var(--lineHeight) / 3));
                }

                &:nth-child(3) {
                    height: var(--lineHeight);
                }

                &:nth-child(4) {
                    height: calc(var(--lineHeight) / 2 );
                }

                &:nth-child(1) {
                    animation: living_icon_playing infinite 1s ease-in-out 0s;
                }

                &:nth-child(2) {
                    animation: living_icon_playing infinite 1s ease-in-out .3s;
                }

                &:nth-child(3) {
                    animation: living_icon_playing infinite 1s ease-in-out .6s;
                }

                &:nth-child(4) {
                    animation: living_icon_playing infinite 1s ease-in-out .8s;
                }
            }
        }

        @keyframes living_icon_playing {
            0% {
                height: calc(var(--lineHeight) / 2 );
            }

            50% {
                height: var(--lineHeight);
            }

            100% {
                height: calc(var(--lineHeight) / 2 );
            }
        }

        .unlive_icon .item {
            animation: unset !important;
        }

        .text {
            margin-left: 3px;
        }
    }
</style>